<header class="modal-header nb-modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <button class="close" aria-label="Close" (click)="onCloseClicked()">
    <i class="fas fa-times" aria-hidden="true"></i>
  </button>
</header>
